module.exports = __webpack_public_path__ + "static/img/10039.8aedcfad.png";